export default "__VITE_ASSET__DL4yBDAI__"